export default {
  clients: "Les clients",
  edition: "Edition d'un client",
  pref_language:"Langue",
  add_contact:"Add a contact",
  timeline:"Timeline",
  modify:"Modifier le client",
  back: "Les clients",
  follow_up: "Suivi du client",
  historical: "Historique",
  create: "Créer un client",
  is_activated: "Client actif",
  client_infos: "Informations client",
  properties_suggestion: "Suggestion de biens",
  source: "Source",

  add_event: "Ajouter un événement",
  add_deal: "Ajouter un deal",
  event_type: "Type d'événement",
  add_follow_up: "Ajouter au suivi",

  properties_visit: "Visite de biens",
  appointment: "Rendez-vous",
  note: "Note",
  other: "Autre",
  title: "Titre",
  description: "Description",
  date: "Date",
  add_email: "Ajouter un email",
  add_phone: "Ajouter un numéro",
  popup: {
    add_title: "Ajouter un titre",
    add_description: "Ajouter une description",
    add_time: "Définir une heure",
  },
  hours: "Heures",
  no_client: "No client",
  no_event: "No event",

  notifications: {
    saved: "Client saved",
  },
  lead:"Lead",
  booking:"Booking",
  buying:"Buying",
  trading:"Trading",
  searching:"Searching",
  specifications:"Specifications",
  priority_level:"Priority level",
  very_low:"Très bas",
  low:"Bas",
  medium:"Moyen",
  high:"Haut",
  very_high:"Très haut",

  deal_saved:"Deal sauvegardé",
  event_saved:"Evénement sauvegardé",
  is_already_done:"Déjà réalisé",
  associated_properties:"Propriétés associées",
  state:"Etat",
  expected_date:"Date souhaitée",
  expected_price:"Prix souhaité",
  professional:"Professionnel",
  private:"Privé",

};
